import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b4c284d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "product-consultation-info"
}

import {ref,watch} from 'vue'
import {message} from 'ant-design-vue'
import {copyTextToClipboard} from '@/utils/help'
import {useProductConsultationText} from '@/utils/productConsultation'

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductConsultationInfo',
  setup(__props) {

const text=useProductConsultationText(),copied=ref(false)
watch(text,()=>{copied.value=false})
async function copy(){
  const value=text.value;if(!value)return
  let success=false
  try{if(navigator.clipboard?.writeText){await navigator.clipboard.writeText(value);success=true}}catch{/* 浏览器不允许剪贴板接口时，继续使用现有复制方式。 */}
  if(!success)success=copyTextToClipboard(value)
  if(text.value===value)copied.value=success
  if(success)message.success('已复制，请在客服对话中粘贴发送')
  else message.warning('复制未完成，请选中咨询信息手动复制')
}

return (_ctx: any,_cache: any) => {
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_unref(text))
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createVNode(_component_a_textarea, {
          value: _unref(text),
          readonly: "",
          rows: 3,
          "aria-label": "当前咨询信息"
        }, null, 8, ["value"]),
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: copy
        }, {
          default: _withCtx(() => [
            _createTextVNode("复制咨询信息")
          ]),
          _: 1
        }),
        _createElementVNode("p", null, _toDisplayString(copied.value?'已复制，请在客服对话中粘贴发送':'复制后在客服对话中粘贴发送，带上当前商品或列表。'), 1)
      ]))
    : _createCommentVNode("", true)
}
}

})